import React from "react";

const CustomChatbotIcons = ({
  color,
  secondaryColor,
  // tertiaryColor,
  height,
  width,
  name = "smileBoxChatbot",
}) => {
  return <>{IconsDetails(color, secondaryColor, height, width, name)?.icon}</>;
};

export const IconsDetails = (
  color,
  secondaryColor,
  // tertiaryColor,
  height,
  width,
  name = "smileBoxChatbot"
) => {
  // Default secondary color if not provided
  const secondary = secondaryColor || (color === "#000000" ? "#666666" : color);
  // const tertiary = tertiaryColor || (color === "#000000" ? "#666666" : color);

  let icons = [
    {
      name: "smileChatbot",
      color: color,
      secondaryColor: secondary,
      height,
      width,
      svg: `<svg
          width="${width || "40px"}"
          height="${height || "40px"}"
          viewBox="-2 -2 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="scale(0.8) translate(2.5, 2.5)">
            <circle cx="8" cy="8" r="9" fill="${secondary || "none"}" stroke="${
        color || "#000000"
      }" stroke-width="1"/>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="${color || "#000000"}"
              d="M8.48 4h4l.5.5v2.03h.52l.5.5V8l-.5.5h-.52v3l-.5.5H9.36l-2.5 2.76L6 14.4V12H3.5l-.5-.64V8.5h-.5L2 8v-.97l.5-.5H3V4.36L3.53 4h4V2.86A1 1 0 0 1 7 2a1 1 0 0 1 2 0 1 1 0 0 1-.52.83V4zM12 8V5H4v5.86l2.5.14H7v2.19l1.8-2.04.35-.15H12V8zm-2.12.51a2.71 2.71 0 0 1-1.37.74v-.01a2.71 2.71 0 0 1-2.42-.74l-.7.71c.34.34.745.608 1.19.79.45.188.932.286 1.42.29a3.7 3.7 0 0 0 2.58-1.07l-.7-.71z"
            />
            <path
              fill="${color || "#000000"}"
              d="M6.49 6.5h-1v1h1v-1zm3 0h1v1h-1v-1z"
            />
          </g>
        </svg>`,
    },
    {
      name: "parrallel",
      color: color,
      secondaryColor: secondary,
      height,
      width,
      svg: `<svg
          width="${width || "40px"}"
          height="${height || "40px"}"
          viewBox="-2 -2 28 28"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="scale(0.8) translate(2.5, 2.5)">
            <circle cx="10.5" cy="10.5" r="13" fill="${
              secondary || "none"
            }" stroke="${color || "rgb(44, 169, 188)"}" stroke-width="1.5"/>
         
            <g transform="scale(0.65) translate(4.2, 4.2)">
              <path
                id="secondary"
                d="M17,4v8a1,1,0,0,1-1,1H7L3,17V4A1,1,0,0,1,4,3H16A1,1,0,0,1,17,4Z"
              />
              <path
                id="primary"
                fill="${secondary || "none"}"
                d="M8,17h9l4,4V7a1,1,0,0,0-1-1H17"
                style="stroke:${
                  color || "rgb(44, 169, 188)"
                }; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
              />
              <path
                id="primary-2"
                fill="${secondary || "none"}"
                d="M17,4v8a1,1,0,0,1-1,1H7L3,17V4A1,1,0,0,1,4,3H16A1,1,0,0,1,17,4Z"
                style="stroke: ${
                  color || "rgb(44, 169, 188)"
                }; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
              />
            </g>
          </g>
        </svg>`,
    },
    {
      name: "smileChatbotAntenna",
      color: color,
      secondaryColor: secondary,
      height,
      width,
      svg: `<svg
          width="${width || "40px"}"
          height="${height || "40px"}"
          viewBox="-2 -2 19 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="scale(0.8) translate(2.5, 2.5)">
            <circle cx="8" cy="8" r="9" fill="${secondary || "none"}" stroke="${
        color || "black"
      }" stroke-width="1"/>
            <g transform="scale(0.85) translate(1.125, 1.125)">
              <path
                fill="${color || "black"}"
                d="M8.99996 2.49988L8.99996 1.99988L8.99996 2.49988ZM5.99995 2.4999L5.99995 2.9999L5.99995 2.4999ZM12.8556 11.9222L12.5051 11.5656L12.3012 11.7661L12.3705 12.0434L12.8556 11.9222ZM13.5 14.4999L13.3788 14.985C13.5492 15.0276 13.7294 14.9776 13.8536 14.8534C13.9778 14.7293 14.0277 14.549 13.9851 14.3786L13.5 14.4999ZM9.50005 13.5L9.14649 13.1464L8.52204 13.7709L9.37879 13.985L9.50005 13.5ZM9.52482 13.4752L9.87838 13.8287C10.0275 13.6796 10.067 13.453 9.97722 13.2623C9.88743 13.0715 9.68761 12.9575 9.4777 12.9774L9.52482 13.4752ZM0.5 7.99988L0 7.99988L0.5 7.99988ZM7 0V2.5H8V0H7ZM8.99996 1.99988L5.99994 1.9999L5.99995 2.9999L8.99997 2.99988L8.99996 1.99988ZM15 7.99988C15 4.68615 12.3137 1.99985 8.99996 1.99988L8.99997 2.99988C11.7614 2.99985 14 5.23844 14 7.99988H15ZM13.2061 12.2787C14.3128 11.1908 15 9.67513 15 7.99988H14C14 9.39612 13.4284 10.6579 12.5051 11.5656L13.2061 12.2787ZM13.9851 14.3786L13.3407 11.8009L12.3705 12.0434L13.015 14.6212L13.9851 14.3786ZM9.37879 13.985L13.3788 14.985L13.6213 14.0148L9.62131 13.0149L9.37879 13.985ZM9.17127 13.1216L9.14649 13.1464L9.8536 13.8535L9.87838 13.8287L9.17127 13.1216ZM9.00001 13.9999C9.19278 13.9999 9.38357 13.9908 9.57194 13.973L9.4777 12.9774C9.32061 12.9923 9.16127 12.9999 9.00001 12.9999V13.9999ZM5.99999 13.9999H9.00001V12.9999H5.99999V13.9999ZM0 7.99988C-9.17912e-06 11.3136 2.68628 13.9999 5.99999 13.9999V12.9999C3.23857 12.9999 0.999992 10.7613 0.999992 7.99988L0 7.99988ZM5.99994 1.9999C2.68626 1.99993 9.17912e-06 4.6862 0 7.99988L1 7.99988C1.00001 5.23849 3.23855 2.99993 5.99995 2.9999L5.99994 1.9999Z"
              />
              <path
                fill="${color || "black"}"
                d="M7.5 8C6.67157 8 6 7.32843 6 6.5H5C5 7.88071 6.11929 9 7.5 9V8ZM9 6.5C9 7.32843 8.32843 8 7.5 8V9C8.88071 9 10 7.88071 10 6.5H9ZM7.5 5C8.32843 5 9 5.67157 9 6.5H10C10 5.11929 8.88071 4 7.5 4V5ZM7.5 4C6.11929 4 5 5.11929 5 6.5H6C6 5.67157 6.67157 5 7.5 5V4Z"
              />
            </g>
          </g>
        </svg>`,
    },
    {
      name: "smileBoxChatbot",
      color: color,
      secondaryColor: secondary,
      height,
      width,
      svg: `<svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-2 -2 20 20"
          width="${width || "40px"}"
          height="${height || "40px"}"
        >
          <g transform="scale(0.8) translate(2.5, 2.5)">
            <circle cx="8" cy="8" r="9" fill="${secondary || "none"}" stroke="${
        color || "black"
      }" stroke-width="1"/>
            <path
              fill="${color || "black"}"
              d="M12 3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9.5l-3 2a0.5 0.5 0 0 1-.75-.25L5.5 13H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8z"
            />
            <path
              fill="${secondary || "none"}"
              d="M9.5 8.5a0.5 0.5 0 0 0-.7 0 1.5 1.5 0 0 1-2.1 0 0.5 0.5 0 0 0-.7.7 2.5 2.5 0 0 0 3.5 0 0.5 0.5 0 0 0 0-.7zM6 6a0.5 0.5 0 0 0 0 1h0.01a0.5 0.5 0 0 0 0-1H6zm3 0a0.5 0.5 0 0 0 0 1h0.01a0.5 0.5 0 0 0 0-1H9z"
            />
          </g>
        </svg>`,
    },
    {
      name: "sideCutChatbot",
      color: color,
      secondaryColor: secondary,
      height,
      width,
      svg: `<svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-2 -2 28 28"
          width="${width || "40px"}"
          height="${height || "40px"}"
        >
          <g transform="scale(0.8) translate(2.5, 2.5)">
            <circle cx="11" cy="11" r="13" fill="${
              secondary || "none"
            }" stroke="${color || "black"}" stroke-width="1"/>
            <g transform="scale(0.8) translate(3.5, 3.5)">
              <path
                fill="${color || "black"}"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 2v2a4 4 0 0 0-4 4v2h8V8a4 4 0 0 0-4-4z"
              />
              <path
                fill="${color || "black"}"
                d="M14.5 7a0.75 0.75 0 1 1-1.5 0 0.75 0.75 0 0 1 1.5 0zm3 0a0.75 0.75 0 1 1-1.5 0 0.75 0.75 0 0 1 1.5 0zM4 2h8.5a6 6 0 0 0-6 6v2h8v6H6l-4 4V4h2z"
              />
            </g>
          </g>
        </svg>`,
    },
  ];
  let embeddingIcon = icons.filter(
    (item) =>
      item.name?.toLowerCase() === name?.toLowerCase().trim() && item.svg
  )?.[0]?.svg;

  return {
    icon: <div dangerouslySetInnerHTML={{ __html: embeddingIcon }}></div>,
    embeddedIcon: embeddingIcon,
  };
};

export default CustomChatbotIcons;
